import axios from '@/libs/api.request.js'

export default {
    // 登录
    login: (data) => {
        return axios.request({
            url: 'agent/login',
            data,
            method: 'post'
        })
    },

    // 注册
    register: (data) => {
        return axios.request({
            url: 'agent/register',
            data,
            method: 'post'
        })
    },

    // 商户列表
    merchantList: (data) => {
        return axios.request({
            url: 'agent/merchantList',
            data,
            method: 'post'
        })
    },

    // 个人信息修改
    updateInfo: (data) => {
        return axios.request({
            url: 'agent/updateInfo',
            data,
            method: 'post'
        })
    },
    // 个人信息
    getInfo: () => {
        return axios.request({
            url: 'agent/info',
            method: 'get'
        })
    },

    // 新增商户
    addMerchant: (data) => {
        return axios.request({
            url: 'agent/addMerchant',
            data,
            method: 'post'
        })
    },

    // 收入记录
    incomeRecord: (data) => {
        return axios.request({
            url: 'agent/incomeRecord',
            data,
            method: 'post'
        })
    },

    // 提现记录
    withdrawalRecord: (data) => {
        return axios.request({
            url: 'agent/withdrawalRecord',
            data,
            method: 'post'
        })
    },

    // 提现
    withdrawal: (data) => {
        return axios.request({
            url: 'agent/withdrawal',
            data,
            method: 'post'
        })
    }, 
}